module.exports = "<div #baAmChart class=\"ba-am-chart {{baAmChartClass || ''}}\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baAmChart/baAmChart.html
// module id = 512
// module chunks = 16